import{jsx as o}from"react/jsx-runtime";import{Link as t}from"react-router-dom";import{styled as e}from"styled-components";import{useLocalizedContents as i}from"../../../../messages/context/LocalizedContentsContext.mjs";const m=e.div`
  width: 160px;
  height: 38px;
  float: left;

  .logo-image {
    padding-top: 4px;
    padding-left: 16px;
  }
`;function r(){const{msg:e}=i();return o(m,{className:"logo",children:o(t,{to:"/information",children:o("img",{className:"logo-image",src:"images/small_logo.png",alt:"ProShip",title:e.ico01005})})})}export{r as Logo};
